import MicroModal from 'micromodal';
import naja from 'naja';

export default class Modal {
    static init(): void {
        MicroModal.init({
            openTrigger: 'data-micromodal-trigger', // Atribut pro spuštění modalu
            closeTrigger: 'data-micromodal-close', // Atribut pro zavření modalu
            disableScroll: true, // Zakáže scrollování při otevřeném modalu
            disableFocus: false, // Povolí/zakáže auto-focus na prvním prvku
            awaitOpenAnimation: false, // Čeká na dokončení animace při otevření
            awaitCloseAnimation: false, // Čeká na dokončení animace při zavření
        });

        Modal.setupCustomOpenModal();
        Modal.setupSnippetListener();
    }

    private static setupCustomOpenModal(): void {
        const openButtons = document.querySelectorAll('[data-micromodal-trigger]');
        openButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const modalId = button.getAttribute('data-micromodal-trigger');
                if (modalId) {
                    MicroModal.show(modalId); // Ruční otevření modálního okna
                }
            });
        });
    }

    private static setupSnippetListener(): void {
        naja.snippetHandler.addEventListener('afterUpdate', () => {
            // Reinitialize modal triggers after snippet updates
            Modal.setupCustomOpenModal();
            
            // Check if any modal is visible, if not, ensure body scroll is restored
            const visibleModal = document.querySelector('.modal[aria-hidden="false"]');
            if (!visibleModal) {
                // No modal is visible, ensure body overflow is reset
                document.body.style.overflow = '';
            }
        });
        
        // Also listen to successful form submissions to clean up scroll lock
        naja.addEventListener('success', () => {
            // Small delay to ensure modal close animation completes
            setTimeout(() => {
                const visibleModal = document.querySelector('.modal[aria-hidden="false"]');
                if (!visibleModal) {
                    document.body.style.overflow = '';
                }
            }, 300);
        });
    }
}
